import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import ArrowRightIcon from 'assets/images/Dashboard/arrow-right-detail.svg';
import NextIcon from 'assets/images/Dashboard/nextIcon.svg';
import PrevIcon from 'assets/images/Dashboard/prevIcon.svg';
import ClockIcon from 'assets/images/Dashboard/clock.svg';
import CalerderIcon from 'assets/images/Dashboard/calendar.svg';
import { doctorAppointmentsUpcomingDetails } from 'routes/AppUrls';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getAppointmentUpcoming } from 'store/getAppointment/getUpcomingAppointment/getUpcomingAppointmentAction';
import ReusableButton from 'components/commom/Button';
import { ClearTokenRedirectLogin } from 'utils/general';
import {
  basicDetailsValue,
  UPCOMING_ID,
} from 'store/BasicDetailValues/BasicDetailValuesAction';
import Shimmer from 'components/commom/Shimmer';
import CommonToast from 'components/commom/CommonToast';

const UpcomingTodayList = ({ tab }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const { locale } = useContext(LocaleContext);
  const todayDay = new Date();
  const [appointmentTodayList, setAppointmentTodayList] = useState([]);

  const loading = useSelector(
    (state) => state?.getAppointmentUpcomigReducer?.loading
  );

  useEffect(() => {
    getAppointmentUpcomingList();
  }, []);

  const getAppointmentUpcomingList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setAppointmentTodayList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getAppointmentUpcoming(external, moment(todayDay).format('YYYY-MM-DD'))
    );
  };

  const handleNavigateUpcoming = (id) => {
    navigate(doctorAppointmentsUpcomingDetails(locale, id));
    dispatch(basicDetailsValue(UPCOMING_ID, id));
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        onClick={onClick}
      >
        <Image src={NextIcon} alt="icon" />
      </div>
    );
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        onClick={onClick}
      >
        <Image src={PrevIcon} alt="icon" />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      {appointmentTodayList && appointmentTodayList.length > 0 && (
        <>
          <div className="pt-32 fc-292D32 fs-20 family_outfit_semiBold_600">
            <FormattedMessage id="Appointments Today" />
          </div>
          <Row className="m-0 pt-8 flex items-start">
            <Col sm={12} md={12} className="p-0 m-0">
              <Slider
                {...settings}
                className={`${
                  locale === 'en'
                    ? 'sliderDetailsEn single-item-slider'
                    : 'sliderDetailsAr single-item-slider'
                }`}
              >
                {appointmentTodayList.map((item, index) => (
                  <div key={index} className="pr-3">
                    <Card className="p-12 subscription-card">
                      <Card.Body className="p-0">
                        <Card.Title>
                          <div className="flex m-0 p-0 justify-between">
                            <div className="fs-18 fc-292D32 lh-2268 family_outfit_semiBold_600 p-0 m-0">
                              {loading ? (
                                <Shimmer width="150px" height="20px" />
                              ) : (
                                item?.patient?.full_name
                              )}
                            </div>
                            <Image
                              src={
                                item?.consultation_type === 'Hospital Visit'
                                  ? HospitalIcon
                                  : VideoCallCameraIcon
                              }
                              alt={'image'}
                            />
                          </div>
                        </Card.Title>
                        <Card.Text>
                          <Stack
                            direction="horizontal"
                            gap={5}
                            className="items-center pt-04"
                          >
                            {loading ? (
                              <Shimmer width="150px" height="20px" />
                            ) : (
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="items-center"
                              >
                                <Image src={CalerderIcon} alt="icon" />
                                <div className="fs-16 fc-292D32 lh-201  family_outfit_medium_500">
                                  {moment(item?.appointment_date_time).format(
                                    'MMMM D, YYYY'
                                  )}
                                </div>
                              </Stack>
                            )}
                            {loading ? (
                              <Shimmer width="150px" height="20px" />
                            ) : (
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="items-center"
                              >
                                <Image src={ClockIcon} alt="icon" />
                                <div className="fs-16 fc-292D32 lh-201  family_outfit_medium_500">
                                  {moment(item?.appointment_date_time).format(
                                    'hh:mmA'
                                  )}
                                </div>
                              </Stack>
                            )}
                          </Stack>
                          {loading ? (
                            <Shimmer
                              width="150px"
                              height="20px"
                              marginTop="20px"
                            />
                          ) : (
                            <div className="pt-20 fs-14 lh-21 fc-998A7B family_outfit_regular_400">
                              Booking ID:
                              <span className="fc-3C3C3C">
                                {item?.booking_id}
                              </span>
                            </div>
                          )}

                          <Row className="pt-16">
                            <Col lg={7}>
                              <ReusableButton
                                fullWidth={true}
                                variant="outlined"
                                color="#FFFFFF"
                                fontSize="14px"
                                fontWeight="500"
                                padding="12px 35px"
                                height="44px"
                                bgColor=" #864629"
                                brColor="transparent"
                                fontFamily="outfit_medium"
                              >
                                <FormattedMessage id="Start Consultation" />
                              </ReusableButton>
                            </Col>
                            <Col lg={5} className="py-0 pl-0 flex justify-end">
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="flex items-center"
                              >
                                <div
                                  className="fs-16 fc-C56616 family_outfit_medium_500 cursor-pointer"
                                  onClick={() =>
                                    handleNavigateUpcoming(item?.id)
                                  }
                                >
                                  <FormattedMessage id="View Details" />
                                </div>
                                <Image
                                  src={ArrowRightIcon}
                                  alt="icon"
                                  style={{ height: '16px', width: '16px' }}
                                  onClick={() =>
                                    handleNavigateUpcoming(item?.id)
                                  }
                                  className="cursor-pointer"
                                />
                              </Stack>
                            </Col>
                          </Row>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Slider>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default UpcomingTodayList;
